// extracted by mini-css-extract-plugin
export default {"adhesion7":"AdherenceCells_adhesion7__+V9n8","adhesionTotal":"AdherenceCells_adhesionTotal__dMrCN"};